import PropTypes from "prop-types";
import { connect } from "react-redux";
import StepControl from "./stepControl";
import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "../../../../utils/customModal";
import { getSpk } from "../../../../../Redux/reducer/env";
import * as instanceActions from "../../../../../Redux/api";
import { encryptPassword } from "../../../../utils/functions";
import { loadingHtml, errorContainer } from "../../../../utils/functions";

import UserIcon from "../../../../../../static/images/user-icon.svg";
import LockIcon from "../../../../../../static/images/lock-icon.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ShowIcon from "../../../../../../static/images/show-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class Step1 extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {
        username: "",
        key: "",
        confirm_key: "",
        hideUserpass: true,
        hideConsPass: true,
      },
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
      errors: {
        username: "",
        key: "",
        confirm_key: "",
      },
    };
  }

  componentDidMount() {
    // seteo del state una vez montado el componente

    const { user: userProp } = this.props;
    const { user } = this.state;

    user.username = userProp.username;
    user.key = userProp.key;
    user.confirm_key = userProp.confirm_key;

    this.setState({ user });
  }

  handlerChange(event) {
    // Limpiamos los errores
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    // Estamos limpiando la contraseña
    /* istanbul ignore else */
    if (element.indexOf("key") != -1) {
      switch (element) {
        case "key":
          user.hideUserpass = true;
          break;
        case "confirm_key":
          user.hideConsPass = true;
          break;
      }
    }

    this.setState({ user });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        key={`clear-${element}`}
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  showInput(event, element) {
    event.preventDefault();
    const { user } = this.state;

    switch (element) {
      case "key":
        user.hideUserpass = !user.hideUserpass;
        this.setState({ user });
        break;
      case "confirm_key":
        user.hideConsPass = !user.hideConsPass;
        this.setState({ user });
        break;
    }
  }

  showUserpass(element) {
    return this.state.user[element] != "" ? (
      <div
        className="button-auto input-w-aux__action show-password fix-show-button"
        onClick={(event) => this.showInput(event, element)}
      >
        <img src={ShowIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  submitForm(e) {
    e.preventDefault();
    const { user, errors } = this.state;

    // validamos campos vacios
    if (
      window.location.pathname === "/credentials/reset"
        ? user.key != "" && user.confirm_key != ""
        : user.username != "" && user.key != "" && user.confirm_key != ""
    ) {
      errors.username = "";
      errors.key = "";
      errors.confirm_key = "";
      this.setState({ errors });
      /* istanbul ignore else */
      if (this.validatePassword()) {
        //si todo va bien vamos al paso 2
        const { user, modal } = this.state;
        const {
          instance: { instanceAction },
        } = this.props;

        const data = {
          authCode: this.props.registerInfo.authCode,
          refCode: this.props.registerInfo.refCode,
          newCodUser: encryptPassword(this.state.user.username, this.props.spk),
          usrAccess: encryptPassword(this.state.user.key, this.props.spk),
          usrAccessConfirmation: encryptPassword(
            this.state.user.confirm_key,
            this.props.spk
          ),
        };

        modal.show = true;
        this.setState({ modal });
        return instanceAction(
          `/self-enrollment/usr-access/${
            window.location.pathname === "/credentials/reset" ? true : false
          }`,
          "put",
          data
        )
          .then(() => {
            this.props.submitStep(true, {
              username: user.username,
              password: user.key,
              confirm_password: user.confirm_key,
            });
          })
          .catch((err) => {
            if (
              err.response !== undefined &&
              Array.isArray(err.response.data.notifications)
            ) {
              const notification = err.response.data.notifications[0];
              modal.modalMessage = {
                title: notification.message,
                message: notification.description,
              };
            }
            modal.type = "error";
            this.setState({ modal });
          });
      }
    } else {
      if (window.location.pathname === "/credentials/reset") {
        if (user.key == "") {
          errors.key = "Debe completar este campo";
        }
        if (user.confirm_key == "") {
          errors.confirm_key = "Debe completar este campo";
        }
        this.setState({ errors });
      } else {
        /* istanbul ignore else */
        if (user.username == "") {
          errors.username = "Debe completar este campo";
        }
        /* istanbul ignore else */
        if (user.key == "") {
          errors.key = "Debe completar este campo";
        }
        /* istanbul ignore else */
        if (user.confirm_key == "") {
          errors.confirm_key = "Debe completar este campo";
        }
        this.setState({ errors });
      }
    }
  }

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;
    //modalMessage
    switch (type) {
      case "loading":
        return loadingHtml();
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          this.closeModal
        );
    }
  };

  validate = () => {
    const { user, errors } = this.state;
    if (user.key == user.confirm_key) {
      // Contraseña válida
      errors.username = "";
      errors.key = "";
      this.setState({ errors });
      return true;
    } else {
      errors.key = "Las contraseñas no coinciden";
      this.setState({ errors });
      this.inputErrors("key", true);

      return false;
    }
  };

  validatePassword() {
    const { user, errors } = this.state;
    var regexp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/);
    var regeCodUser = new RegExp(/^[a-zA-Z\d]{8,32}$/);
    var result = regexp.test(user.key);
    var resultCodUser = regeCodUser.test(user.username);
    if (window.location.pathname == "/register/auto-enrolment") {
      if (resultCodUser) {
        if (result) {
          if (user.key.toLowerCase() != user.username.toLowerCase()) {
            return this.validate();
          } else {
            //Nombre de usuario y contraseña no deben coincidir
            errors.username =
              "El nombre de usuario y contraseña no deben coincidir";
            errors.key = "El nombre de usuario y contraseña no deben coincidir";
            this.setState({ errors });

            this.inputErrors("username");
            this.inputErrors("key");

            return false;
          }
        } else {
          // La contraseña no coincide con el patrón
          errors.key = "La contraseña no coincide con el formato establecido";
          this.setState({ errors });

          this.inputErrors("key", true);

          return false;
        }
      } else {
        errors.username =
          "El código de usuario no coincide con el el formato establecido";
        this.setState({ errors });

        this.inputErrors("username", true);

        return false;
      }
    } else {
      if (result) {
        if (user.key.toLowerCase() != user.username.toLowerCase()) {
          if (user.key == user.confirm_key) {
            // Contraseña válida
            errors.key = "";
            this.setState({ errors });
            return true;
          } else {
            errors.key = "Las contraseñas no coinciden";
            this.setState({ errors });
            this.inputErrors("key", true);

            return false;
          }
        } else {
          //Nombre de usuario y contraseña no deben coincidir
          errors.key = "El nombre de usuario y contraseña no deben coincidir";
          this.setState({ errors });
          this.inputErrors("key");

          return false;
        }
      } else {
        // La contraseña no coincide con el patrón
        errors.key = "La contraseña no coincide con el formato establecido";
        this.setState({ errors });

        this.inputErrors("key", true);

        return false;
      }
    }
  }

  inputErrors(id, hasFocus = false) {
    if (
      document.getElementById(id) !== null &&
      document.getElementById(id) !== undefined
    ) {
      document.getElementById(id).classList.add("input--error");

      if (hasFocus) {
        document.getElementById(id).focus();
      }
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-1">
        {this.props.spk !== undefined &&
          this.props.spk !== "" &&
          window.location.pathname == "/register/auto-enrolment" && (
            <div className="user-content-info">
              <h1>Detalles del usuario en proceso de registro</h1>
              <div className="row user-info">
                <div className="col">
                  <h3>Nombre</h3>
                  {this.props.registerInfo !== undefined && (
                    <p>{this.props.registerInfo.firstName}</p>
                  )}
                </div>
                <div className="col">
                  <h3>Apellido</h3>
                  {this.props.registerInfo !== undefined && (
                    <p>{this.props.registerInfo.lastName}</p>
                  )}
                </div>
              </div>
            </div>
          )}
        <div className="user-credentials">
          {this.props.spk !== undefined &&
          this.props.spk !== "" &&
          window.location.pathname === "/register/auto-enrolment" ? (
            <h1>Defina un nombre de usuario y una contraseña</h1>
          ) : (
            <h1>Defina una contraseña</h1>
          )}
          <div className="login-form">
            <form
              className="login"
              action="post"
              onSubmit={(e) => this.submitForm(e)}
            >
              {this.props.spk !== undefined &&
                this.props.spk !== "" &&
                window.location.pathname === "/register/auto-enrolment" && (
                  <div className="input-w-aux">
                    <img
                      className="button input-w-aux__icon"
                      src={UserIcon}
                      alt={`Usuario`}
                    />
                    <input
                      id="username"
                      name="username"
                      type="text"
                      className="input input--text input-w-aux__input input--active"
                      autoComplete="off"
                      placeholder={`Usuario`}
                      value={this.state.user.username}
                      onChange={(event) => this.handlerChange(event)}
                      data-tip
                      data-for="username-disclaimer"
                    />
                    {this.closeButton("username")}
                    {this.displayError("username")}
                    <ReactTooltip
                      id="username-disclaimer"
                      className="info-tooltip"
                      type="light"
                      effect="solid"
                      place="right"
                      offset={{ top: 0 }}
                      event="focus"
                      eventOff="focusout"
                    >
                      <div className="tooltip-content">
                        <p>
                          El nombre de usuario debe tener la siguiente
                          estructura:
                        </p>
                        <ul>
                          <li>10 o más caracteres de extensión</li>
                          <li>Debe ser alfanumérico</li>
                          <li>No debe contener espacios</li>
                          <li>
                            No se permiten caracteres especiales (ej: !$%&)
                          </li>
                        </ul>
                      </div>
                    </ReactTooltip>
                  </div>
                )}
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="key"
                  name="key"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideUserpass ? "password" : "text"}
                  placeholder={`Contraseña`}
                  autoComplete="off"
                  value={this.state.user.key}
                  onChange={(event) => this.handlerChange(event)}
                  data-tip
                  data-for="password-disclaimer"
                />
                {this.closeButton("key")}
                {this.showUserpass("key")}
                <ReactTooltip
                  id="password-disclaimer"
                  className="info-tooltip"
                  type="light"
                  effect="solid"
                  place="right"
                  offset={{ top: 0 }}
                  event="focus"
                  eventOff="focusout"
                >
                  <div className="tooltip-content">
                    <p>La contraseña debe tener la siguiente estructura:</p>
                    <ul>
                      <li>8 o más caracteres de extensión</li>
                      <li>Se requiere al menos una letra minúscula</li>
                      <li>Se requiere al menos una letra mayúscula</li>
                      <li>Se requiere al menos un número</li>
                      <li>No debe contener espacios</li>
                      <li>No debe contener su nombre de usuario</li>
                      <li>No se permiten caracteres especiales (ej: !$%&)</li>
                    </ul>
                  </div>
                </ReactTooltip>
                {this.displayError("key")}
              </div>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Confirmar contraseña`}
                />
                <input
                  id="confirm_key"
                  name="confirm_key"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideConsPass ? "password" : "text"}
                  placeholder={`Confirmar contraseña`}
                  autoComplete="off"
                  value={this.state.user.confirm_key}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("confirm_key")}
                {this.showUserpass("confirm_key")}
                {this.displayError("confirm_key")}
              </div>
              <StepControl
                currentStep={1}
                submitStep={(e) => this.submitForm(e)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          hideClose={modal.type == "loading"}
          handleClose={() => this.closeModal()}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

Step1.propTypes = {
  user: PropTypes.object.isRequired,
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    registerInfo: state.sessionInfoReducer.registerInfo,
    spk: getSpk(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch)(Step1));
